import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiChannel } from 'core/constants';

import { ModelBase } from 'store/model-base';
import { buildHeaders, XmStore } from 'core/services';

import { StoreAction } from 'store/actions';
import { NowNotificationBannerCollection } from './models/collection';

@Injectable()
export class NowNotificationBannerApi {
    public static getNowNotificationBannerCollection(_xmStore: XmStore, http: HttpClient, params: ApiParams): Observable<NowNotificationBannerCollection> {
        return http.get(`/now/notifications/line/${params.lineId}`, {
            headers: buildHeaders({ apiChannel: ApiChannel.SSM_GATEWAY })
        }).pipe(
            map((response: ApiResponse) => NowNotificationBannerCollection.create<NowNotificationBannerCollection>({ ...response, lineId: params.lineId }))
        );
    }
}

ModelBase.fetchMapping[StoreAction.GET_NOW_NOTIFICATION_BANNER_COLLECTION] = NowNotificationBannerApi.getNowNotificationBannerCollection;
